<wl-partial-card [shadow]="false" class="bg-light">
  <ng-container slot="header"
    ><h4 *wlGenericRichText="rendering().fields.title"></h4
  ></ng-container>
  <ng-container slot="subheader">
    <p *wlGenericRichText="rendering().fields.bodyText"></p>
  </ng-container>
  <ng-container slot="content">
    <form>
      <div class="mb-2">
        <wl-cookie-settings-category
          title="Functionele en analytische cookies"
          class="mb-2"
        >
          <ng-container slot="action">Altijd actief</ng-container>
          <ng-container slot="content"
            ><p
              *wlGenericRichText="rendering().fields.alwaysActiveDetailText"
            ></p
          ></ng-container>
        </wl-cookie-settings-category>
        <wl-cookie-settings-category title="Tracking cookies">
          <ng-container slot="action">
            <div class="me-1">
              @if (trackingCookiesChecked()) {
                <span>Akkoord</span>
              }
              @if (!trackingCookiesChecked()) {
                <span>Niet akkoord</span>
              }
            </div>
            <wl-toggle
              [(checked)]="trackingCookiesChecked"
              (toggle)="onToggle($event)"
            ></wl-toggle
          ></ng-container>
          <ng-container slot="content"
            ><p
              *wlGenericRichText="rendering().fields.trackingCookiesDetailText"
            ></p
          ></ng-container>
        </wl-cookie-settings-category>
      </div>
      <wl-partial-button
        role="button"
        theme="primary"
        type="submit"
        wlAutomationId="cookie-settings-cta"
        [loading]="submittingSettings()"
        (clicked)="submitSettings()"
      >
        Opslaan
      </wl-partial-button>
    </form>
  </ng-container>
</wl-partial-card>
